import { emailRegExp } from "utils";
import { localization } from "../../utils";
import snackbar from "components/snackbar";
import setLoading from 'components/loading';
import validate from '../../validations'

export default {
  refreshOn: () => [],
  init: ({ selectedOptionId }, stateManager, _) => stateManager.setLanguage(localization(selectedOptionId)),
  'Header.Section.Wrapper.LanguageDropdown': ({ selectedOptionIds }, stateManager) => {
    const { selectedLanguage } = stateManager.store.getState()
    const newSelectedLang = ((selectedOptionIds.length > 0) ? selectedOptionIds[0] : selectedLanguage);
    stateManager.setSelectedLanguage(newSelectedLang)
    stateManager.setLanguage(localization(newSelectedLang))
  },
  'Header.Section.Wrapper.Email': ({ occupants, value, action }, stateManager) => {
    if (action === 'change') {
      const updatedOccupant = { ...occupants[0], email: value }
      const updatedOccupants = [...occupants]
      updatedOccupants.splice(0, 1, updatedOccupant)
      stateManager.setOccupants(updatedOccupants)
      validate(500)
    } else {
      const { property, language } = stateManager.store.getState()
      const email = occupants[0].email

      const isValidEmail = emailRegExp(email)
      if (!isValidEmail) {
        snackbar({
          message: language?.landing_page_errors?.email_error,
          args: { type: 'error' }
        });

        return
      }

      const payload = {
        "client_schema": window.CLIENT_SCHEMA,
        "property_id": property?.id,
        "email": email
      }

      setLoading(true)
      stateManager.saveIsEmailExist(payload)
        .then((r) => {
          const { email, pin } = r.data
          if (!pin) stateManager.setSelectedTabId("occupants")
          else {
            stateManager.setIsEmailExist({
              pin,
              email,
              emailExist: true,
            })
          }
          setLoading(false)
          return
        })
        .catch((e) => {
          setLoading(false)
          snackbar({
            message: e?.response?.data?.error || e?.message,
            args: { type: 'error' }
          });

        })
    }
  },
};
